import produce from 'immer';
import _ from 'lodash';

import {
  ORDER_ASCENDING,
  ORDER_DESCENDING
} from '../../../utils/constants/tableConstants';
import moshiConfig from '../../../utils/moshiConfig';
import {
  setFilterToStoreDraft,
  setFiltersToStoreDraft
} from '../../../utils/redux/listUtils';

import {
  CLEAR_INVOICE_DETAIL,
  CLEAR_INVOICE_PAYMENTS_LIST,
  CLEAR_INVOICE_LIST_FILTER,
  GET_INVOICE_DETAIL_FAILURE,
  GET_INVOICE_DETAIL_IN_PROGRESS,
  GET_INVOICE_DETAIL_SUCCESS,
  GET_INVOICE_LIST_FAILURE,
  GET_INVOICE_LIST_IN_PROGRESS,
  GET_INVOICE_LIST_SUCCESS,
  GET_INVOICE_PAYMENTS_LIST_FAILURE,
  GET_INVOICE_PAYMENTS_LIST_IN_PROGRESS,
  GET_INVOICE_PAYMENTS_LIST_SUCCESS,
  SET_INVOICE_LIST_FILTER,
  SET_INVOICE_LIST_FILTERS,
  SET_INVOICE_LIST_ORDER,
  SET_INVOICE_LIST_PAGINATION,
  UPDATE_INVOICE_SUCCESS,
  PATCH_INVOICE_SUCCESS,
  VOID_INVOICE_SUCCESS,
  SET_INVOICE_LIST_INCLUDE_PARAM,
  CLEAR_INVOICE_LIST_FILTER_NO_POLL
} from './invoiceTypes';

import { LOGOUT } from '../../auth/authReducer';

import InvoiceModel from '../../../metadata/model/billing/bill/InvoiceModel';

export const initialState = {
  list: [],
  loadingList: false,
  detail: null,
  loadingDetail: false,
  filter: {
    sortBy: 'issuedAt',
    order: ORDER_DESCENDING
  },
  include: '',
  pagination: {
    resultCount: 0,
    pageCount: 0,
    limit: _.get(moshiConfig, 'list.pagination.limit', 20),
    page: 1
  },
  payments: {
    loadingPaymentsList: false,
    list: []
  }
};

// eslint-disable-next-line default-param-last
const invoiceReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    const { type, ...payload } = action;

    switch (type) {
      case GET_INVOICE_LIST_IN_PROGRESS:
        draft.loadingList = true;
        break;
      case GET_INVOICE_LIST_SUCCESS:
        const responsePayload = _.getNonEmpty(payload, 'response', payload);
        const billingInvoices = _.getNonEmpty(responsePayload, 'data', []);

        const maxResultsRaw = _.getNonEmpty(
          responsePayload,
          'headers.x-total-count',
          draft.pagination.limit
        );
        const maxResults = _.parseInt(maxResultsRaw);

        draft.pagination.resultCount = maxResults;
        draft.pagination.pageCount = _.ceil(
          maxResults / draft.pagination.limit
        );

        draft.loadingList = false;
        draft.list = _.sortBy(billingInvoices, 'name');
        break;
      case GET_INVOICE_LIST_FAILURE:
        draft.loadingList = false;
        break;
      case GET_INVOICE_DETAIL_IN_PROGRESS:
        draft.loadingDetail = true;
        break;
      case GET_INVOICE_DETAIL_SUCCESS:
      case UPDATE_INVOICE_SUCCESS:
      case PATCH_INVOICE_SUCCESS:
      case VOID_INVOICE_SUCCESS:
        const invoice = InvoiceModel.fromDto(
          _.get(payload, 'response.data', {})
        );

        draft.loadingDetail = false;
        draft.detail = invoice;
        break;
      case GET_INVOICE_DETAIL_FAILURE:
        draft.loadingDetail = false;
        break;
      case CLEAR_INVOICE_DETAIL:
        draft.detail = null;
        break;
      case SET_INVOICE_LIST_FILTER:
        setFilterToStoreDraft(draft, payload, initialState.pagination.page);
        break;
      case SET_INVOICE_LIST_FILTERS:
        const filters = _.getNonEmpty(payload, 'filters', []);

        setFiltersToStoreDraft(draft, filters, initialState.pagination.page);

        break;
      case SET_INVOICE_LIST_ORDER:
        const sortBy = _.getNonEmpty(payload, 'sortBy', null);
        const order = _.get(payload, 'order', ORDER_ASCENDING);

        draft.filter.sortBy = sortBy;
        draft.filter.order = order;
        break;
      case SET_INVOICE_LIST_PAGINATION:
        const paginationName = _.getNonEmpty(payload, 'paginationName', null);
        const paginationValue = _.get(payload, 'paginationValue', '');

        if (!_.isEmpty(paginationName)) {
          draft.pagination[paginationName] = paginationValue;
        }
        break;
      case GET_INVOICE_PAYMENTS_LIST_IN_PROGRESS:
        draft.payments.loadingPaymentsList = true;
        break;
      case GET_INVOICE_PAYMENTS_LIST_SUCCESS:
        const invoicePayments = _.get(payload, 'response.data', []);

        draft.payments.list = invoicePayments;
        break;
      case GET_INVOICE_PAYMENTS_LIST_FAILURE:
        draft.payments.loadingPaymentsList = false;
        break;
      case CLEAR_INVOICE_PAYMENTS_LIST:
        draft.payments.loadingPaymentsList = false;
        draft.payments.list = [];
        break;
      case CLEAR_INVOICE_LIST_FILTER:
      case CLEAR_INVOICE_LIST_FILTER_NO_POLL:
        draft.filter = initialState.filter;
        break;
      case SET_INVOICE_LIST_INCLUDE_PARAM:
        draft.include = _.get(payload, 'includeValue');
        break;
      case LOGOUT:
        return initialState;
      default:
    }
  });

export default invoiceReducer;
